<template>
    <nav :class="classes" class="navbar navbar-expand-lg">
        <div class="container navcontainer">
            <div class="navbar-translate">
                <slot v-bind="slotData"></slot>
                <navbar-toggle-button :toggled="showMenu" @click.native.stop="toggle"></navbar-toggle-button>
            </div>
            <div :class=" showMenu ? 'overlay collapse navbar-collapse show' : 'collapse navbar-collapse show'"
                 v-if="$slots['navbar-menu'] || $scopedSlots['navbar-menu']"
                 data-color="orange"
                 id="navigation">
                <ul class="navbar-nav" :class="menuClasses" v-click-outside="close">
                    <slot name="side-menu" v-bind="slotData"></slot>
                    <slot name="navbar-menu" v-bind="slotData"></slot>
                </ul>
            </div>
        </div>
    </nav>
</template>
<script>
  import { CollapseTransition } from 'vue2-transitions';
  import NavbarToggleButton from './NavbarToggleButton';
  let resizeTimeout;
  function resizeThrottler(actualResizeHandler) {
    // ignore resize events as long as an actualResizeHandler execution is in the queue
    if ( !resizeTimeout ) {
      resizeTimeout = setTimeout(() => {
        resizeTimeout = null;
        actualResizeHandler();

        // The actualResizeHandler will execute at a rate of 15fps
      }, 66);
    }
  }


  export default {
    name: 'navbar',
    props: {
      transparent: {
        type: Boolean,
        default: true
      },
      position: {
        type: String,
        default: 'relative'
      },
      classes: {
        type: [String, Object, Array]
      },
      menuClasses: {
        type: [String, Object, Array]
      },
      colorOnScroll: {
        type: Number,
        default: 0
      },
      type: {
        type: String,
        default: 'white',
        validator(value) {
          return ['white', 'default', 'primary', 'danger', 'success', 'warning', 'info'].includes(value);
        }
      },
    },
    provide() {
      return {
        closeNavbar: this.close
      }
    },
    components: {
      CollapseTransition,
      NavbarToggleButton
    },
    data() {
      return {
        showMenu: false,
        extraNavClasses: '',
        currentScrollValue: 0
      }
    },
    computed: {
      classes2() {
        let color = `bg-${this.type}`;
        let navPosition = `navbar-${this.position}`;
        let colorOnScrollTransparent = this.colorOnScroll && this.currentScrollValue < this.colorOnScroll;
        if (this.position === 'fixed') {
          navPosition = 'fixed-top';
        }

        let classes = [
          { 'navbar-transparent': (this.transparent || colorOnScrollTransparent) },
          { [color]: (!this.transparent && this.colorOnScroll === 0) },
          navPosition, this.extraNavClasses]
          console.log('classes', classes)
      },
      slotData(){
        return {
          toggle: this.toggle,
          open: this.open,
          close: this.close,
          isClosed: this.closed,
          isToggled: this.showMenu
        }
      },
    },
    methods: {
      setNav(value){
        let docClasess = document.body.classList;
        if(value){
          docClasess.add('nav-open', 'overlay')
        } else {
          docClasess.remove('nav-open')
          setTimeout(() => {
          docClasess.remove('overlay')
          }, 250)
        }
        let isOpen = docClasess.contains('nav-open');
        let eventToTrigger = isOpen ? 'open' : 'close';
        if ( !isOpen ) {
        setTimeout(() => {this.showMenu = isOpen;}, 500);
        } else {
        this.showMenu = isOpen;
        }
        this.$emit(eventToTrigger)
      },
      toggle() {
        this.setNav(!this.showMenu)
      },
      open(){
        this.setNav(true);
      },
      close(){
        if (this.showMenu === false) {
          return
        }
        this.setNav(false);
      },
      scrollListener() {
      }
    },
    mounted () {
        console.log('type', this.type);
        this.$root.$on('navbar-mobile', (action) => {
	      if (action === 'close') {
        this.close()
	      } else {
	      this.open()
	      }
              });
      var container = document.getElementById('app')
    },
    beforeDestroy () {
      var container = document.getElementById('app')
    }
  }
</script>
<style>
body.nav-open #page-overlay {
                    z-index: 999998;
                    opacity: 0.8;
                    }

body.overlay #app.scrolled .navbar, body.overlay #app.unscrolled .navbar, body.overlay #app .navbar.fixed-top {
background-color: transparent !important;
}
/*
body.nav-open #navigation {
box-shadow: -300px 0px 20px 20px #040404c9;
}
body #navigation {
box-shadow: -20px 0px 20px 20px #04040400;
}
*/
body .navbar {
transition: all 0.3s;
}
body .container.navcontainer {
width: 100% !important;
min-width: 100% !important;
padding: 0 20px 0 20px;
font-size: 12px !important;
font-weight: 700 !important;
font-family: Lato, sans-serif !important;
letter-spacing: 0.185em !important;
}
body .container.navcontainer .navbar-brand, body .container.navcontainer .nav-item {
margin-right: 1rem;
margin-top: -10px;
}
body .container.navcontainer .nav-item.dropdown {
margin-right: -5px;
}
body.frontpage .container.navcontainer .nav-item.dropdown, body.discussions .container.navcontainer .nav-item.dropdown, body.faq .container.navcontainer .nav-item.dropdown {
margin-right: 15px;
}
</style>
